import Vue from 'vue';
import { getReservationReport } from '../../../services/personnelService/reservationService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  reservationReports: []
};

// getters
const getters = {};

// actions
const actions = {
  // 取得報表
  async getReservationReportHandler({ commit }, formData) {
    const data = await getReservationReport(formData);
    commit('setReservationReport', data);
  },
};

// mutations
const mutations = {
  setReservationReport(state, data) {
    Vue.set(state, 'reservationReports', data.data.personnel);
  },
  // 重置所有資料
  resetHandler(state) {
    Vue.set(state, 'reservationReports', []);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
